import { COMPANY_INITIALS, COMPANY_SHORT } from '../constants';

const navItems = [
  { label: 'About', href: '#about' },
  { label: 'Profile details', href: '#care' },
  { label: 'Visit', href: '#visit' },
];

function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-line/70 bg-cream/85 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <a
          href="#top"
          className="flex min-w-0 items-center gap-3"
          aria-label={`${COMPANY_SHORT} home`}
        >
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-plum text-sm font-black text-petal shadow-ring">
            {COMPANY_INITIALS}
          </span>
          <span className="font-display truncate text-xl font-semibold text-plum sm:text-2xl">
            {COMPANY_SHORT}
          </span>
        </a>
        <nav
          className="hidden items-center gap-2 md:flex"
          aria-label="Primary"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-pill px-4 py-2 text-sm font-semibold text-ink/70 transition hover:bg-petal hover:text-plum"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <a
          href="#visit"
          className="rounded-pill bg-plum px-5 py-2.5 text-sm font-semibold text-petal transition hover:bg-rose"
        >
          Find us
        </a>
      </div>
    </header>
  );
}

export default Header;
